import { render, staticRenderFns } from "./nodeWrap.vue?vue&type=template&id=598ab3bc&scoped=true"
import script from "./nodeWrap.vue?vue&type=script&lang=js"
export * from "./nodeWrap.vue?vue&type=script&lang=js"
import style0 from "./nodeWrap.vue?vue&type=style&index=0&id=598ab3bc&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "598ab3bc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\zjj\\view-pc\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('598ab3bc')) {
      api.createRecord('598ab3bc', component.options)
    } else {
      api.reload('598ab3bc', component.options)
    }
    module.hot.accept("./nodeWrap.vue?vue&type=template&id=598ab3bc&scoped=true", function () {
      api.rerender('598ab3bc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/workFlow/nodeWrap.vue"
export default component.exports